import { render, staticRenderFns } from "./BoundingBox.vue?vue&type=template&id=5f411eaf&scoped=true&"
import script from "./BoundingBox.vue?vue&type=script&lang=js&"
export * from "./BoundingBox.vue?vue&type=script&lang=js&"
import style0 from "./BoundingBox.vue?vue&type=style&index=0&id=5f411eaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f411eaf",
  null
  
)

export default component.exports